import React, { ReactNode } from 'react'
import cx from 'classnames'
import styleProvider from '@quotatisgroup/uikit-public.style-provider'
import './link.scss'

export type LinkProps = JSX.IntrinsicElements['a'] & {
  className?: string
  classes?: string
  children?: ReactNode | string
  href?: string
  icon?: string
  iconPosition?: 'right' | 'left'
  iconSize?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
  isBlock?: boolean
  id: string
  bold?: boolean
}

const LinkComponent = ({
  children,
  href = '#',
  icon,
  iconPosition,
  iconSize,
  isBlock = false,
  classes,
  className,
  id,
  bold = false,
  ...otherProps
}: LinkProps) => {
  return (
    <a
      id={id}
      href={href}
      className={cx(
        classes,
        {
          [`icon-${iconPosition}`]: iconPosition,
          [`size-${iconSize}`]: iconSize,
          block: isBlock,
          bold,
        },
        className,
      )}
      {...otherProps}
    >
      {icon && (
        <img
          className="icon-link"
          src={`https://res.cloudinary.com/quotatis/image/upload/FrontApp/vitrine/icon/${icon}.svg`}
          alt="icon"
        />
      )}
      {children}
    </a>
  )
}

export const Link = styleProvider(LinkComponent)
